import { render, staticRenderFns } from "./ModalRecoverPassword.vue?vue&type=template&id=7109827a&"
import script from "./ModalRecoverPassword.vue?vue&type=script&lang=js&"
export * from "./ModalRecoverPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports